import useWidth from "app/hooks/useWidth";
import { useTheme } from "app/shared";
import { ReactComponent as Arrow } from "assets/img/icons/arrow.svg";
import { FC, useEffect, useState } from "react";
import styles from "./stages-widget.module.scss";

interface Stage {
  label: string;
  value: string;
}

interface StageWidgetProps {
  stages: Stage[];
  extraStages?: Stage[];
}

const StageWidget: FC<StageWidgetProps> = ({ stages, extraStages }) => {
  const { isSmallDesktop, isTablet, isMobile } = useWidth();
  const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return "TBA";
    const date = new Date(dateString);
    return `by ${date.getUTCFullYear()}/${String(
      date.getUTCMonth() + 1
    ).padStart(2, "0")}/${String(date.getUTCDate()).padStart(2, "0")} ${String(
      date.getUTCHours()
    ).padStart(2, "0")}:${String(date.getUTCMinutes()).padStart(2, "0")} (UTC)`;
  };

  const { theme } = useTheme();
  const now = new Date();

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsHidden(
        (window.innerWidth > 1024 && window.innerWidth < 1440) ||
          isSmallDesktop ||
          isMobile ||
          isTablet
      );
    };

    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);

    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, [isSmallDesktop, isMobile, isTablet]);

  const currentStageIndex = stages.findIndex((stage, index) => {
    const stageDate = stage.value ? new Date(stage.value) : null;
    const nextStageDate = stages[index + 1]?.value
      ? new Date(stages[index + 1].value)
      : null;

    if (!stage.value) {
      return (
        index === stages.length - 1 || now >= new Date(stages[index - 1]?.value)
      );
    }

    if (stageDate && stageDate <= now) {
      return !nextStageDate || now < nextStageDate;
    }

    return false;
  });

  return (
    <div
      className={`${styles.stageWidget} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      {stages.map((stage, index) => (
        <div key={stage.label} className={styles.stageWrapper}>
          <div
            className={`${styles.stageItem} ${
              index <= currentStageIndex ? styles.active : ""
            } ${theme === "dark" ? styles.darkTheme : ""}`}
          >
            <div
              className={`${styles.stageNumber} ${
                index <= currentStageIndex ? styles.activeNumber : ""
              } ${theme === "dark" ? styles.darkTheme : ""}`}
            >
              {index + 1}
            </div>
            {index < stages.length - 1 && (
              <div className={styles.lineContainer}>
                <div
                  className={`${styles.line} ${
                    index <= currentStageIndex ? styles.activeLine : ""
                  }`}
                  style={{
                    width: stages.length === 2 ? "440px" : "220px",
                    display: isHidden ? "none" : "block",
                  }}
                />
                <Arrow
                  className={`${styles.arrow} ${
                    index <= currentStageIndex ? styles.activeArrow : ""
                  }`}
                />
                <div
                  className={`${styles.line} ${
                    index <= currentStageIndex ? styles.activeLine : ""
                  }`}
                  style={{
                    width: stages.length === 2 ? "440px" : "220px",
                    display: isHidden ? "none" : "block",
                  }}
                />
              </div>
            )}
          </div>
          <div
            className={`${styles.stageDetails} ${
              index <= currentStageIndex ? styles.active : ""
            } ${theme === "dark" ? styles.darkTheme : ""}`}
          >
            <span
              className={`${styles.stageName} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              {stage.label}
            </span>
            <span
              className={`${styles.stageDate} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              {formatDate(stage.value)}
            </span>

            {/* {stage.label === "Guaranteed Round" && extraStages && (
              <div className={styles.wrapper}>
                <StageDop stages={extraStages} isLoading={false} />
              </div>
            )} */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StageWidget;
